import feedbackMethods from './Feedbacks'
import feedbackIdMethods from './Feedbacks.id'

export const FeedbackServices = {
  ...feedbackMethods,
  id: feedbackIdMethods
}

export * from './Feedbacks.types'
